export const NOTIFY_APPOINTMENT = "NOTIFY_APPOINTMENT"
export const NOTIFY_SYSTEM = "NOTIFY_SYSTEM"
export const MARK_AS_READ = "MARK_AS_READ"
